import { MatchGauge } from "PFComponents/resource_metrics/match_gauge";
import { MatchScores } from "PFTypes";
import { ComponentProps, ReactNode } from "react";

import css from "../profile_card.module.scss";

type GaugeProps = Partial<Omit<ComponentProps<typeof MatchGauge>, "match">>;

type ProfileCardTopRightCornerProps = {
  scores?: MatchScores;
  headerActions?: ReactNode;
  topRightCornerNode?: ReactNode;
  gaugeProps?: GaugeProps;
};

export const ProfileCardTopRightCorner = ({
  scores,
  headerActions,
  topRightCornerNode,
  gaugeProps = {}
}: ProfileCardTopRightCornerProps) => (
  <div className={css.topRightCorner}>
    {scores && <MatchGauge match={{ scores }} className={css.match} {...gaugeProps} />}
    {headerActions && <div className={css.headerActions}>{headerActions}</div>}
    {topRightCornerNode}
  </div>
);
